import { render, staticRenderFns } from "./ViewActivoPage.vue?vue&type=template&id=05fb21e6&scoped=true"
import script from "./ViewActivoPage.vue?vue&type=script&lang=js"
export * from "./ViewActivoPage.vue?vue&type=script&lang=js"
import style0 from "./ViewActivoPage.vue?vue&type=style&index=0&id=05fb21e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fb21e6",
  null
  
)

export default component.exports